import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { LemlistCandidates } from '@/features/lemlist-candidates'

const searchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  filter: z.string().optional().catch(''),
  seniority: z.string().optional().catch(undefined),
  industry: z.string().optional().catch(undefined),
  qualityScore: z.number().optional().catch(undefined),
  sort: z.string().optional().catch(undefined),
  sortDir: z.enum(['asc', 'desc']).optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/lemlist-candidates/')({
  validateSearch: searchSchema,
  component: LemlistCandidates,
})
